import { Construction } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

export function ComingSoonPage() {
  return (
    <div className="mx-auto max-w-2xl py-16">
      <Card>
        <CardContent className="py-16 text-center">
          <div className="mx-auto mb-5 grid size-12 place-items-center rounded-2xl bg-slate-100 text-slate-500">
            <Construction className="size-6" />
          </div>
          <h1 className="text-2xl font-semibold tracking-tight text-slate-950">Coming in Phase 2</h1>
          <p className="mx-auto mt-3 max-w-md text-sm leading-6 text-slate-500">This area is reserved for the next operational module. The Phase 1 foundation is ready for review.</p>
        </CardContent>
      </Card>
    </div>
  );
}
